// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"113348e4","453":"935cf98a"}[chunkId] + ".chunk.js";
};